import { NumberParam, StringParam, useQueryParams } from 'use-query-params'

import { GetLogisticCartsParams } from 'redux/services/logistic-cart/types'

import { LogisticCartStatus } from 'models/logistic_cart'

export const useLogisticCartFilters = () => {
  const [query, setQuery] = useQueryParams(
    {
      limit: NumberParam,
      offset: NumberParam,
      search: StringParam,
      pan: StringParam,
      start_date: StringParam,
      end_date: StringParam,
      status: StringParam,
    },
    {
      removeDefaultsFromUrl: true,
    },
  )

  const params: GetLogisticCartsParams = {
    limit: Number(query.limit || 10),
    offset: Number(query.offset || 0),
    search: query.search || '',
    pan: query.pan || '',
    start_date: query.start_date || '',
    end_date: query.end_date || '',
    status: (query.status as LogisticCartStatus) || undefined,
  }

  const resetParams = () => {
    setQuery({}, 'replace')
  }

  const setParam = (key: keyof GetLogisticCartsParams, value: string) => {
    setQuery({
      [key]: value || undefined,
    })
  }

  const deleteParam = (key: keyof GetLogisticCartsParams) => {
    setQuery({
      [key]: undefined,
    })
  }

  return {
    params,
    setParam,
    deleteParam,
    resetParams,
  }
}
